import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/terms-and-privacy/")({
  staticData: {
    title: "home.termsAndPrivacy",
  },
});
